import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { matchPath, useLocation, useNavigate, useNavigationType } from "react-router";
import { useTranslation } from "react-i18next";

import { useMatchMedia } from "primereact/hooks";
import { PanelMenu } from "primereact/panelmenu";

import { faCalendarAlt, faCloud, faFileInvoiceDollar, faList, faListAlt, faSeedling, faTree, faTruck, faUserCog, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { setTreeState } from "../Menubar/FarmTreeView";
import { putLog } from "../../utils/logcache";

const nodeNav = (node, navigate) => {
    try {
        const node_id = node && node.id;

        const [object_id, parent] = node_id?.split("_") || [];
        const expanded = { state: { expanded: [object_id] } };

        if (object_id === "priceList") {
            navigate({ pathname: "/billing/priceList" }, expanded);
        } else if (object_id === "clientparams") {
            navigate({ pathname: "/billing/clientparams" }, expanded);
        } else if (object_id === "farmssummary") {
            navigate({ pathname: "/billing/farmssummary" }, expanded);
        } else if (object_id === "management") {
            navigate({ pathname: "/billing/management" }, expanded);
        } else if (object_id === "managementDealer") {
            navigate({ pathname: "/billing/management/dealer" }, expanded);
        } else if (object_id === "managementFarm") {
            navigate({ pathname: "/billing/management/farm" }, expanded);
        } else if (object_id === "managementClient") {
            navigate({ pathname: "/billing/management/client" }, expanded);
        }  else if (object_id === "integratorsBilling") {
            navigate({ pathname: "/billing/integrators" }, expanded);
        } else {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
    }
};

const SelectedItemContext = createContext(null);

const TranslateElementsPrime = ({ data, options, setSelectedItem }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const selectedItem = useContext(SelectedItemContext);
    const [objeto_id] = data?.id?.split("_") ?? [];

    if (data === null || data === undefined || data.id === null) return null;
    const [objeto] = (data.id && data.id.split("-")) || [];

    return(
        <div className="toogleIconwrapper">
            {
                data?.id?.includes("-")?
                    data?.items?.length > 0 ?
                        <div className="toogleIcon"><i style={{ fontSize: "1rem", paddingTop:"0.5rem" }} className={options?.active?"pi pi-angle-down":"pi pi-angle-right"} onClick={options?.onClick}  /></div>
                        : <div className='iconFiller' />
                    :null
            }
            <div
                onClick={(args) => {
                    if (data?.items?.length > 0) {
                        options?.onClick(args);
                    } else {
                        const [objeto_id] = data?.id?.split("_") ?? [];
                        const navigated = nodeNav(data, navigate);
                        if (navigated) setSelectedItem(objeto_id);
                    }
                    args.stopPropagation();
                }}
                className={`treeview-texts-prime
          ${data.level !== 1 && data.tag !== "title" ? "normal" : ""}
          ${data.tag === "title" && data.level !== 1 ? "title" : ""}
          ${(objeto_id && selectedItem === objeto_id) ? "activeNode" : ""}`}
                style={{display:"flex", alignItems:"baseline"}}
            >
                {
                    data?.custom_icon?
                        data?.custom_icon:
                        data?.icon ? (
                            <span className={`menu-icon-external ${data.level !== 1 && data.tag !== "title" ?"ml-4":""}`}>
                                <FontAwesomeIcon className="faIcon" size="lg" icon={data.icon} />
                            </span>
                        ) : null
                }
                <span className="menu-icons-prime" /><p className="orden-solo uppercase">{data.label || t(`billing.sideBar.${data.name}`)}</p>
                {data?.items?.length > 0 ? <i className={options?.active ? "pi pi-minus" : "pi pi-plus"} onClick={(args) => {
                    options?.onClick(args);
                    args.stopPropagation();
                }}
                /> : null}
            </div>
        </div>
    );
};

const treeData = [
    {
        id: "priceList",
        name: "priceList",
        icon: faList,
        level: 1,
        tag: "title"
    },{
        id: "clientparams",
        name: "clientParams",
        icon: faCloud,
        level: 1,
        tag: "title"
    },{
        id: "farmssummary",
        name: "farmssummary",
        icon: faTree,
        level: 1,
        tag: "title"
    },{
        id: "management",
        name: "management",
        icon: faFileInvoiceDollar,
        tag: "title",
        level:1
    },{
        id: "integratorsBilling",
        name: "integratorsBilling",
        icon: faTruck,
        level: 1,
        tag: "title"
    },
    /*{
    id: 'documents',
    name: "documents.name",
    icon: faFile,
    level:1,
    tag:"title",
    subChild: [
      { id: 'docFarm', name: "documents.farm"},
      { id: 'docClient', name: "documents.client"},
      { id: 'docIntegrator', name: "documents.integrator"},
    ],
  },*/
];

const StateReseter = ({ setSelectedItem }) => {
    const menuTreeNodes = treeData;
    const action = useNavigationType();
    const location = useLocation();

    useEffect(() => {
        const { pathname, state } = location || {};

        if (state && (action === "POP" || state.updateTree)) {
            setTreeState(menuTreeNodes, null, setSelectedItem, state && state.expanded);
        } else if (action && matchPath("/billing/personal/", pathname)) {
            // clean selected nodes if, for example, we are in "/personal" or "/account"
            setSelectedItem(null);
        }

        putLog("new loc:" + pathname + ", action: " + action, 2);
    }, [menuTreeNodes, location, action]);

    return null;
};

const BillingMenubar = ({ setMenuIsOpen }) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const navigate = useNavigate();
    const mediaQuery = "(min-width: 600px)";

    const isMobile = !useMatchMedia(mediaQuery);
    useEffect(() => {
        setMenuIsOpen(!isMobile);
    }, [isMobile]);

    const model = useMemo(() => {
        const nodeTemplate = (data, options) => <TranslateElementsPrime data={data} options={options} setSelectedItem={setSelectedItem} />;

        treeData.forEach(t => {
            t.template = nodeTemplate;
            if(t.items?.length>0){
                t.items.forEach(i => {
                    i.template = nodeTemplate;
                });
            }
        });
        return treeData;
    }, [navigate]);

    return (
        <div id="sidebar-menu" className="sidebar-content treeview-container treeview-nomax main-menu">
            <StateReseter setSelectedItem={setSelectedItem} />
            <SelectedItemContext.Provider value={selectedItem}>
                <PanelMenu
                    id="treeviewbilling"
                    model={model}
                    multiple
                />
            </SelectedItemContext.Provider>
        </div>
    );
};

export default BillingMenubar;
